var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<script type="text/html"id="categories-templ"><div class="form-group"data-bind="validationApplyMessagePlacement"> <select class="form-control margin-bottom-ms-1"data-bind="value:SelectedChildId, options:Children, optionsText:\'Name\', optionsCaption:\'-- Выберите характер обращения --\', optionsValue:\'CategoryId\'"></select> </div><!-- ko foreach: Children --><!-- ko if: $data.hasChildren --> <div class="width-xs-auto widh-sm-34rem clearfix"data-bind="template: { data: $data, name:\'categories-templ\' }, visibleAnimated: $parent.SelectedChildId() == CategoryId"></div><!-- /ko --> <!-- /ko --></script>';
}
return __p;
};
